<template>
  <div class="d-flex flex-column align-items-center gap-3">
    <el-dialog :title="captcha.question" :visible.sync="captchaVisible" width="500" append-to-body destroy-on-close :close-on-click-modal="false">
      <div class="d-flex flex-column align-items-center gap-3" v-if="captchaVisible">
        <el-alert :title="alertMsg.msg" :type="alertMsg.type" class="text-break" v-if="alertMsg.visible" :closable="false"></el-alert>

        <canvas id="myCanvas" width="500" height="500" @click="selectImage" />

        <div class="d-flex align-items-center justify-content-between w-100">
          <el-button icon="el-icon-refresh-right" circle @click="getNewCaptcha()"></el-button>
          <el-button type="primary" @click="confirmCaptcha">Xác thực</el-button>
        </div>
      </div>
    </el-dialog>

    <el-alert :title="alertMsg.msg" :type="alertMsg.type" class="text-break" v-if="alertMsg.visible" :closable="false"></el-alert>

    <el-input placeholder="Nhập số điện thoại" v-model="phone" @input="onlyNumber">
      <!--      <template slot="prepend">+84</template>-->
    </el-input>

    <el-button type="primary" class="w-100" :disabled="!isVNPhoneNumber" @click="getCaptcha()">Đăng nhập bằng thiết bị di động</el-button>
  </div>
</template>

<script>
import { v4 as uuidv4 } from "uuid";

export default {
  data() {
    return {
      phone: "",
      sessionId: "",
      captchaVisible: false,
      captcha: {},
      answers: [
        [false, false, false],
        [false, false, false],
        [false, false, false]
      ],
      img: null,
      alertMsg: {
        visible: false,
        type: "primary",
        msg: ""
      }
    };
  },
  computed: {
    isVNPhoneNumber() {
      let regex = /(84|0[3|5|7|8|9])+([0-9]{8})\b/;
      return regex.test(this.phone);
    }
  },
  methods: {
    onlyNumber(event) {
      this.phone = event.replace(/[^0-9]/g, "");
    },
    getCaptcha() {
      this.$http
        .get("/api/zalo/getCaptcha", {
          headers: {
            "x-ssid": this.sessionId
          }
        })
        .then(resp => {
          let data = resp.data;
          if (data.error_code == 0) {
            this.captcha = data.data;
            this.captchaVisible = true;

            this.$nextTick(() => {
              this.drawCanvas();
            });
          } else {
            this.alert("error", "Có lỗi xảy ra khi lấy Captcha");
          }
        });
    },
    drawCanvas() {
      var canvas = document.getElementById("myCanvas");
      var ctx = canvas.getContext("2d");
      this.img = new Image();
      this.img.onload = () => {
        ctx.drawImage(this.img, 0, 0); // Or at whatever offset you like
      };
      this.img.src = this.captcha.image.url;
    },
    selectImage(event) {
      var canvas = document.getElementById("myCanvas");
      var ctx = canvas.getContext("2d");

      let rect = canvas.getBoundingClientRect();

      let puzzleX = event.x;
      let captchaX = rect.left;
      let subX = Math.abs(puzzleX - captchaX);

      let puzzleY = event.y;
      let captchaY = window.screenY + rect.top;
      let subY = Math.abs(puzzleY - captchaY);

      let xPos = Math.ceil(subX / 150);
      let yPos = Math.ceil(subY / 150);

      for (let i = 0; i < this.answers.length; i++) {
        for (let j = 0; j < this.answers[i].length; j++) {
          if (i == xPos - 1 && j == yPos - 1) {
            let x = (xPos - 1) * 150 + (xPos - 1) * 5;
            let y = (yPos - 1) * 150 + (yPos - 1) * 5;
            if (!this.answers[j][i]) {
              this.drawRectangle(ctx, x, y);
            } else {
              ctx.clearRect(x, y, 152, 152);
              ctx.drawImage(this.img, x, y, 150, 150, x, y, 150, 150);
            }
          }
        }
      }

      this.answers[yPos - 1][xPos - 1] = !this.answers[yPos - 1][xPos - 1];
    },
    drawRectangle(ctx, x, y) {
      ctx.beginPath();
      ctx.rect(x, y, 150, 150);
      ctx.fillStyle = "rgba(0,0,0,0.5)";
      ctx.fill();

      ctx.fillStyle = "red";
      ctx.font = "36px serif";
      ctx.fillText("✔", x + 65, y + 85);
      ctx.lineWidth = 2;
      ctx.strokeStyle = "blue";
      ctx.stroke();
      ctx.closePath();
    },
    confirmCaptcha() {
      let request = {
        token: this.captcha.image.token,
        answers: [].concat(...this.answers),
        csrfToken: this.captcha.csrfToken
      };

      this.$http
        .post("/api/zalo/checkCaptcha", request, {
          headers: {
            "x-ssid": this.sessionId
          }
        })
        .then(resp => {
          let data = resp.data;
          if (data.error_code == 0) {
            this.alertMsg.visible = true;
            this.alertMsg.msg = "Vui lòng xác nhận đăng nhập trên thiết bị của bạn!";
            this.alertMsg.type = "success";
            this.captchaVisible = false;
            this.requestLogin(data.data.uuid);
          } else {
            this.alertMsg.visible = true;
            this.alertMsg.msg = data.error_message;
            this.alertMsg.type = "error";
            this.getNewCaptcha();
          }
        })
        .finally(() => {
          this.answers = [
            [false, false, false],
            [false, false, false],
            [false, false, false]
          ];
        });
    },
    requestLogin(captchaResponse) {
      let request = {
        phoneNumber: this.phone,
        captchaResponse: captchaResponse
      };

      this.$http
        .post("/api/zalo/requestLogin", request, {
          headers: {
            "x-ssid": this.sessionId
          }
        })
        .then(resp => {
          this.captchaVisible = false;
          let data = resp.data;
          if (data.error_code == 0) {
            this.alertMsg.visible = false;
            this.alertMsg.msg = "";
            this.alert("success", "Đăng nhập thành công!");
            this.$emit("success");
          } else {
            this.alertMsg.visible = true;
            this.alertMsg.msg = data.error_message ? data.error_message : "Có lỗi xảy ra, vui lòng thử lại sau.";
            this.alertMsg.type = "error";
          }
        });
    },
    getNewCaptcha() {
      this.answers = [
        [false, false, false],
        [false, false, false],
        [false, false, false]
      ];
      this.getCaptcha();
    }
  },

  created() {
    this.sessionId = uuidv4();
  }
};
</script>
